import { b2x } from '@b2x/react/src';

import { AssetA } from '../AssetA';
import { AboutUsPageContentType } from '../contentTypes';
import { CopyA } from '../CopyA';
import { DetailsA } from '../DetailsA';
import { MultiColumnB } from '../MultiColumnB';
import { Page } from './Page';

export interface AboutUsPageProps {}

export const AboutUsPage = (props: AboutUsPageProps) => {
  const page = b2x.usePage<AboutUsPageContentType>();

  return (
    <Page className="about-us-page" noPaddingBottom noPaddingTop>
      {page?.content?.body.firstSection?.options?.enabled && <AssetA {...page.content.body.firstSection} />}
      {page?.content?.body.secondSection?.options?.enabled && <CopyA {...page.content.body.secondSection} />}
      {page?.content?.body.thirdSection?.options?.enabled && <MultiColumnB {...page.content.body.thirdSection} />}
      {page?.content?.body.fourthSection?.options?.enabled && <MultiColumnB {...page.content.body.fourthSection} />}
      {page?.content?.body.fifthSection?.options?.enabled && <DetailsA {...page.content.body.fifthSection} />}
    </Page>
  );
};
